import { render, staticRenderFns } from "./sceen2D.vue?vue&type=template&id=52781b88&scoped=true&"
import script from "./sceen2D.vue?vue&type=script&lang=js&"
export * from "./sceen2D.vue?vue&type=script&lang=js&"
import style0 from "./sceen2D.vue?vue&type=style&index=0&id=52781b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52781b88",
  null
  
)

export default component.exports